import React from 'react';
import { logo } from "../../../utils";
import T from 'prop-types';

export const Logo = ({ className }) => {
    return <img src={logo} className={className} alt="Logo image" />;
};

Logo.T = {
    className: T.string,
};

Logo.defaultProps = {
    className: 'logoDefaultCls',
};
